// shows a form for customer to sign up that creates a stripe customer.
export class StripeCustomerSignup extends HTMLElement {
  constructor(groupId) {
    super();
    this.groupId = groupId;
  }

  async loadData(){
    let url = `/admin/rate_schedules/${this.rateScheduleId}/card_editor_data`
    let res = await fetch(url);
    this.data = await res.json();
    //console.log('StripeCustomerSignup data: ',this.data)
  }

  async connectedCallback() {
    this.innerHTML = `
     
      <form id="payment_info">
       <div class="row">
      <h3>Payment Information</h3>
        <div class="form-group">
          <label for="name_on_card">Name on Card</label>
          <input 
            type='text' 
            id='name_on_card' 
            autocomplete='off'
            class="form-control">
        </div>

        <div class="form-group">
          <label for="card_number">Credit Card Number</label>
          <input 
            type='text' 
            id='card_number' 
            autocomplete='off'
            class="form-control">
        </div>

        <div class="form-group">
          <label for="billing_zip_code">Billing Zip Code</label>
          <input 
            type='text' 
            id='billing_zip_code' 
            autocomplete='off'
            class="form-control">
        </div>

        <div class="form-group">
          <label for="expiration_date">Expiration Date</label>
          <input 
            type='text' 
            id='expiration_date' 
            autocomplete='off'
            class="form-control">
        </div>

        <div class="form-group">
          <label for="cvc">CVC</label>
          <input 
            type='text' 
            id='cvc' 
            autocomplete='off'
            class="form-control">
        </div>
      </div>

      <div class="row">
        <br/>
        <a 
          class="btn btn-outline-primary" 
          id="update_payment_information"
          >Update Billing Settings</a>
      </div>
    </form>

    ` 

    this.querySelector('#update_payment_information').addEventListener('click', function(e){
      this.update_billing_settings()
    }.bind(this))
  }

  async update_billing_settings() {
    const group_id = this.groupId    

    const url = `/admin/groups/${this.groupId}/payment_method_intent`
    let res = await fetch(url);
    let result = await res.json();
    const stripe = Stripe(result.public_key)
    const options = {
      clientSecret: result.client_secret,
    };


    // let name_on_card = this.querySelector('form#payment_info #name_on_card').value
    // let card_number = this.querySelector('form#payment_info #card_number').value
    // let billing_zip_code = this.querySelector('form#payment_info #billing_zip_code').value
    // let expiration_date = this.querySelector('form#payment_info #expiration_date').value
    // let cvc = this.querySelector('form#payment_info #cvc').value

    // const post = {
    //   name_on_card: name_on_card,
    //   card_number: card_number,
    //   billing_zip_code: billing_zip_code,
    //   expiration_date: expiration_date,
    //   cvc: cvc
    // }
    
    // fetch(`/admin/groups/${group_id}/payment_method_intent`,{
    //   headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
    //             'Content-type': 'application/json'},
    //   method: 'POST',
    //   body: JSON.stringify(post)
    // })
    // .then( async (response) => {
    //   // get json response here
    //   let data = await response.json();

      console.log('returned result', result)
      console.log('returned client_secret', result.client_secret)

      if(response.status === 200){
        // Process data here
        if (data.success) {
          Common.notify("Updated payment information successfully", "success");
        }
        else {
          if (data.client_secret === null) {
            Common.notify("Not allowed. Group is already associated with a Stripe account.", "danger");
          }
        }
      }else{
        // Rest of status codes (400,500,303), can be handled here appropriately
        Common.notify(`Failed to update billing. ${data.error}`, "error");
      }
    // })
    // .catch((err) => {
    //   Common.notify(`Error updating billing. ${err}`, "error");
    // })    
  }

  async renderData() {
    await this.loadData()

    const billing_plans_container = this.querySelector('#current_billing_plans_container');
    if (billing_plans_container){
      this.data.map(rate_schedule => {
        billing_plans_container.appendChild(new CurrentBillingPlanInfo(rate_schedule))        
      })
    }
  }

  renderNoData() {
    let html = `<h3>No rate schedule has been selected.</h3>`
    const billing_plans_container = this.querySelector('#current_billing_plans_container');
    billing_plans_container.innerHTML = html
  }
}
customElements.define('stripe-customer-signup', StripeCustomerSignup)



